import React from "react";

import CollapsibleWrapper from "../../components/shared/collapsibleWrapper";
import { stripHtmlTags } from "../../utils/commonFunctions";
import { useBreakpoint } from "../../hooks/useBreakpoint";

export const VIIntro = ({ viOverviewTitle, overviewContent, isProgram }) => {
  const breakpoint = useBreakpoint();

  const summaryCount = breakpoint === "xs" ? 180 : 550;
  return (
    <section className="relative w-full flex justify-center overflow-hidden bg-gray-lighten dark:bg-gray-dark">
      <div className="gvi-container mx-auto pt-32 md:pt-20 pb-12 md:pb-20 tab-content">
        <h1 className="pb-8 md:pb-12 !font-light">{viOverviewTitle}</h1>

        {!isProgram ? (
          <CollapsibleWrapper
            desc={overviewContent}
            summary={
              stripHtmlTags(overviewContent)?.length > summaryCount
                ? `${stripHtmlTags(overviewContent)?.substring(0, summaryCount)}...`
                : overviewContent
            }
            descStyle="pr-3 md:pr-11 dark:text-gray-generic tab-content_html"
            btnStyle="underline underline-offset-2 pt-2 text-gray-generic dark:text-white text-sm flex gap-4 items-center"
            wrapperContainer=""
            visibleLength={summaryCount}
            visibleLines={"none"}
            type={"both"}
            readMoreStyle="sm:!h-full"
          />
        ) : (
          <div
            className="pr-3 md:pr-11 dark:text-gray-generic tab-content_html overflow-y-scroll gvi-scrollbar-thin sm:scrollbar-none sm:overflow-hidden"
            dangerouslySetInnerHTML={{
              __html: overviewContent
            }}
          />
        )}
      </div>
    </section>
  );
};
